<div class="outlet-content">
  <button
    class="supplierAndOutletBtn"
    [ngClass]="{ newOutlet: outlet.outletId === -1 }"
    mat-button
  >
    <div
      class="buttonText"
      [ngClass]="{ buttonTextNewOutlet: outlet.outletId === -1 }"
    >
      {{ outlet.outletName }}
    </div>
    <div class="buttonText supplierOutletDeliveryAddress">
      {{ outlet.address }}
    </div>
  </button>

  <div class="resultOutlet">
    <div>{{ 'determined_by_activation_code' | translate }}</div>
    <div class="resultOutlet-primary-color">
      {{ resultOutlet.outletName }} ({{ resultOutlet.address }})
    </div>
    <div>{{ 'add_catalog_to_outlet' | translate }}</div>
  </div>
</div>
<footer
  [ngClass]="{
    'footer-filter-desktop': !mobile,
    'footer-filter d-flex': mobile
  }"
>
  <button
    [ngClass]="{
      'full-width b2b-button link-button': mobile
    }"
    mat-flat-button
    (click)="selectOutletClick()"
    [disabled]="loading"
  >
    {{ 'select_outlet' | translate }}
  </button>

  <button
    [ngClass]="{
      'primary-button': !mobile,
      'full-width b2b-button active-button': mobile
    }"
    mat-flat-button
    (click)="activateOutlet()"
    [disabled]="loading"
  >
    {{ 'yes' | translate }}
    <mat-spinner
      *ngIf="loading"
      [diameter]="20"
      [strokeWidth]="2"
      [ngStyle]="{ display: 'inline-block' }"
    ></mat-spinner>
  </button>
</footer>
